import { Select } from 'peach/components'

import countryCodes from './countryCodes'

const CountryCodeSelect = (props) => (
  <Select options={countryCodes} searchable {...props} />
)

export default CountryCodeSelect
